// extracted by mini-css-extract-plugin
module.exports = {"icon":"InfoButton_icon__33X9s"};